module.exports = __webpack_public_path__ + "img/enabled.6fb8b675.svg";